/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AssetManagementItem } from '../models/asset-management-item';
import { AssetManagementItemEssential } from '../models/asset-management-item-essential';
import { BaseResponse } from '../models/base-response';
import { EmptyResponse } from '../models/empty-response';
import { IsProductSerializableByWarehouseResponse } from '../models/is-product-serializable-by-warehouse-response';
import { IsProductsSerializableFromWarehouseStockActualByAgreementResponse } from '../models/is-products-serializable-from-warehouse-stock-actual-by-agreement-response';
import { MovableItemList } from '../models/movable-item-list';
import { MovementTypeListResponse } from '../models/movement-type-list-response';
import { StringItem } from '../models/string-item';
import { warehouseControllerCalculateAndGetStockByDate } from '../fn/warehouse/warehouse-controller-calculate-and-get-stock-by-date';
import { WarehouseControllerCalculateAndGetStockByDate$Params } from '../fn/warehouse/warehouse-controller-calculate-and-get-stock-by-date';
import { warehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate } from '../fn/warehouse/warehouse-controller-calculate-and-get-stock-from-warehouse-stock-actual-by-agreement-by-date';
import { WarehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate$Params } from '../fn/warehouse/warehouse-controller-calculate-and-get-stock-from-warehouse-stock-actual-by-agreement-by-date';
import { warehouseControllerCreateAdjustment } from '../fn/warehouse/warehouse-controller-create-adjustment';
import { WarehouseControllerCreateAdjustment$Params } from '../fn/warehouse/warehouse-controller-create-adjustment';
import { warehouseControllerCreateDispose } from '../fn/warehouse/warehouse-controller-create-dispose';
import { WarehouseControllerCreateDispose$Params } from '../fn/warehouse/warehouse-controller-create-dispose';
import { warehouseControllerCreateDisposeDdt } from '../fn/warehouse/warehouse-controller-create-dispose-ddt';
import { WarehouseControllerCreateDisposeDdt$Params } from '../fn/warehouse/warehouse-controller-create-dispose-ddt';
import { warehouseControllerCreateReturn } from '../fn/warehouse/warehouse-controller-create-return';
import { WarehouseControllerCreateReturn$Params } from '../fn/warehouse/warehouse-controller-create-return';
import { warehouseControllerCreateSpecialMove } from '../fn/warehouse/warehouse-controller-create-special-move';
import { WarehouseControllerCreateSpecialMove$Params } from '../fn/warehouse/warehouse-controller-create-special-move';
import { warehouseControllerCreateTransfer } from '../fn/warehouse/warehouse-controller-create-transfer';
import { WarehouseControllerCreateTransfer$Params } from '../fn/warehouse/warehouse-controller-create-transfer';
import { warehouseControllerCreateUnload } from '../fn/warehouse/warehouse-controller-create-unload';
import { WarehouseControllerCreateUnload$Params } from '../fn/warehouse/warehouse-controller-create-unload';
import { warehouseControllerDeleteMovement } from '../fn/warehouse/warehouse-controller-delete-movement';
import { WarehouseControllerDeleteMovement$Params } from '../fn/warehouse/warehouse-controller-delete-movement';
import { warehouseControllerFindSerialsByWarehouseMovement } from '../fn/warehouse/warehouse-controller-find-serials-by-warehouse-movement';
import { WarehouseControllerFindSerialsByWarehouseMovement$Params } from '../fn/warehouse/warehouse-controller-find-serials-by-warehouse-movement';
import { warehouseControllerGenerateStock } from '../fn/warehouse/warehouse-controller-generate-stock';
import { WarehouseControllerGenerateStock$Params } from '../fn/warehouse/warehouse-controller-generate-stock';
import { warehouseControllerGetLoadedSerialNumbers } from '../fn/warehouse/warehouse-controller-get-loaded-serial-numbers';
import { WarehouseControllerGetLoadedSerialNumbers$Params } from '../fn/warehouse/warehouse-controller-get-loaded-serial-numbers';
import { warehouseControllerGetMovable } from '../fn/warehouse/warehouse-controller-get-movable';
import { WarehouseControllerGetMovable$Params } from '../fn/warehouse/warehouse-controller-get-movable';
import { warehouseControllerGetMovement } from '../fn/warehouse/warehouse-controller-get-movement';
import { WarehouseControllerGetMovement$Params } from '../fn/warehouse/warehouse-controller-get-movement';
import { warehouseControllerGetMovements } from '../fn/warehouse/warehouse-controller-get-movements';
import { WarehouseControllerGetMovements$Params } from '../fn/warehouse/warehouse-controller-get-movements';
import { warehouseControllerGetMovementTypes } from '../fn/warehouse/warehouse-controller-get-movement-types';
import { WarehouseControllerGetMovementTypes$Params } from '../fn/warehouse/warehouse-controller-get-movement-types';
import { warehouseControllerGetStockInOffice } from '../fn/warehouse/warehouse-controller-get-stock-in-office';
import { WarehouseControllerGetStockInOffice$Params } from '../fn/warehouse/warehouse-controller-get-stock-in-office';
import { warehouseControllerGetStockOfProduct } from '../fn/warehouse/warehouse-controller-get-stock-of-product';
import { WarehouseControllerGetStockOfProduct$Params } from '../fn/warehouse/warehouse-controller-get-stock-of-product';
import { warehouseControllerIsAssetManagementMovable } from '../fn/warehouse/warehouse-controller-is-asset-management-movable';
import { WarehouseControllerIsAssetManagementMovable$Params } from '../fn/warehouse/warehouse-controller-is-asset-management-movable';
import { warehouseControllerIsSerialInAssetManagement } from '../fn/warehouse/warehouse-controller-is-serial-in-asset-management';
import { WarehouseControllerIsSerialInAssetManagement$Params } from '../fn/warehouse/warehouse-controller-is-serial-in-asset-management';
import { warehouseControllerLoadFromOrder } from '../fn/warehouse/warehouse-controller-load-from-order';
import { WarehouseControllerLoadFromOrder$Params } from '../fn/warehouse/warehouse-controller-load-from-order';
import { warehouseControllerPreviewEmailBody } from '../fn/warehouse/warehouse-controller-preview-email-body';
import { WarehouseControllerPreviewEmailBody$Params } from '../fn/warehouse/warehouse-controller-preview-email-body';
import { warehouseControllerProductsSerializableByWarehouse } from '../fn/warehouse/warehouse-controller-products-serializable-by-warehouse';
import { WarehouseControllerProductsSerializableByWarehouse$Params } from '../fn/warehouse/warehouse-controller-products-serializable-by-warehouse';
import { warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement } from '../fn/warehouse/warehouse-controller-products-serializable-from-warehouse-stock-actual-by-agreement';
import { WarehouseControllerProductsSerializableFromWarehouseStockActualByAgreement$Params } from '../fn/warehouse/warehouse-controller-products-serializable-from-warehouse-stock-actual-by-agreement';
import { warehouseControllerRecalculateallStocks } from '../fn/warehouse/warehouse-controller-recalculateall-stocks';
import { WarehouseControllerRecalculateallStocks$Params } from '../fn/warehouse/warehouse-controller-recalculateall-stocks';
import { warehouseControllerSendEmail } from '../fn/warehouse/warehouse-controller-send-email';
import { WarehouseControllerSendEmail$Params } from '../fn/warehouse/warehouse-controller-send-email';
import { warehouseControllerStock } from '../fn/warehouse/warehouse-controller-stock';
import { WarehouseControllerStock$Params } from '../fn/warehouse/warehouse-controller-stock';
import { warehouseControllerStockFromWarehouseStockActualByAgreement } from '../fn/warehouse/warehouse-controller-stock-from-warehouse-stock-actual-by-agreement';
import { WarehouseControllerStockFromWarehouseStockActualByAgreement$Params } from '../fn/warehouse/warehouse-controller-stock-from-warehouse-stock-actual-by-agreement';
import { WarehouseMovement } from '../models/warehouse-movement';
import { WarehouseMovementSerialsListResponse } from '../models/warehouse-movement-serials-list-response';
import { WarehouseMovementsListResponse } from '../models/warehouse-movements-list-response';
import { WarehouseStockByAgreemntResponse } from '../models/warehouse-stock-by-agreemnt-response';
import { WarehouseStockOfProductResponse } from '../models/warehouse-stock-of-product-response';
import { WarehouseStockResponse } from '../models/warehouse-stock-response';

@Injectable({ providedIn: 'root' })
export class WarehouseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `warehouseControllerPreviewEmailBody()` */
  static readonly WarehouseControllerPreviewEmailBodyPath = '/warehouse/{id}/preview-body';

  /**
   * Preview del body di una mail di movimento di carico.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerPreviewEmailBody()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerPreviewEmailBody$Response(params: WarehouseControllerPreviewEmailBody$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>> {
    return warehouseControllerPreviewEmailBody(this.http, this.rootUrl, params, context);
  }

  /**
   * Preview del body di una mail di movimento di carico.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerPreviewEmailBody$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerPreviewEmailBody(params: WarehouseControllerPreviewEmailBody$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: StringItem;
}> {
    return this.warehouseControllerPreviewEmailBody$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: StringItem;
}>): BaseResponse & {
'data'?: StringItem;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerSendEmail()` */
  static readonly WarehouseControllerSendEmailPath = '/warehouse/{id}/send-email';

  /**
   * Invia una mail per un movimento di carico.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerSendEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerSendEmail$Response(params: WarehouseControllerSendEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return warehouseControllerSendEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia una mail per un movimento di carico.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerSendEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerSendEmail(params: WarehouseControllerSendEmail$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.warehouseControllerSendEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerProductsSerializableByWarehouse()` */
  static readonly WarehouseControllerProductsSerializableByWarehousePath = '/warehouse/products-serializable-by-warehouse';

  /**
   * Restituisce lo stock e la quantità di un determinato prodotto in un determinato magazzino.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerProductsSerializableByWarehouse()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerProductsSerializableByWarehouse$Response(params: WarehouseControllerProductsSerializableByWarehouse$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: IsProductSerializableByWarehouseResponse;
}>> {
    return warehouseControllerProductsSerializableByWarehouse(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce lo stock e la quantità di un determinato prodotto in un determinato magazzino.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerProductsSerializableByWarehouse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerProductsSerializableByWarehouse(params: WarehouseControllerProductsSerializableByWarehouse$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: IsProductSerializableByWarehouseResponse;
}> {
    return this.warehouseControllerProductsSerializableByWarehouse$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: IsProductSerializableByWarehouseResponse;
}>): BaseResponse & {
'data'?: IsProductSerializableByWarehouseResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement()` */
  static readonly WarehouseControllerProductsSerializableFromWarehouseStockActualByAgreementPath = '/warehouse/products-serializable-from-warehouse_stock_actual_by_agreement';

  /**
   * Restituisce lo stock da  e la quantità di un determinato prodotto in un determinato magazzino per una determinata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement$Response(params: WarehouseControllerProductsSerializableFromWarehouseStockActualByAgreement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: IsProductsSerializableFromWarehouseStockActualByAgreementResponse;
}>> {
    return warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce lo stock da  e la quantità di un determinato prodotto in un determinato magazzino per una determinata.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement(params: WarehouseControllerProductsSerializableFromWarehouseStockActualByAgreement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: IsProductsSerializableFromWarehouseStockActualByAgreementResponse;
}> {
    return this.warehouseControllerProductsSerializableFromWarehouseStockActualByAgreement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: IsProductsSerializableFromWarehouseStockActualByAgreementResponse;
}>): BaseResponse & {
'data'?: IsProductsSerializableFromWarehouseStockActualByAgreementResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerGetMovements()` */
  static readonly WarehouseControllerGetMovementsPath = '/warehouse/movements';

  /**
   * Restituisce l'elenco dei movimenti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerGetMovements()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetMovements$Response(params: WarehouseControllerGetMovements$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovementsListResponse;
}>> {
    return warehouseControllerGetMovements(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei movimenti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerGetMovements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetMovements(params: WarehouseControllerGetMovements$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseMovementsListResponse;
}> {
    return this.warehouseControllerGetMovements$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovementsListResponse;
}>): BaseResponse & {
'data'?: WarehouseMovementsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerGetMovementTypes()` */
  static readonly WarehouseControllerGetMovementTypesPath = '/warehouse/movement-types';

  /**
   * Restituisce l'elenco delle tipologie di movimento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerGetMovementTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetMovementTypes$Response(params?: WarehouseControllerGetMovementTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MovementTypeListResponse;
}>> {
    return warehouseControllerGetMovementTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle tipologie di movimento.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerGetMovementTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetMovementTypes(params?: WarehouseControllerGetMovementTypes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MovementTypeListResponse;
}> {
    return this.warehouseControllerGetMovementTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MovementTypeListResponse;
}>): BaseResponse & {
'data'?: MovementTypeListResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerGetMovement()` */
  static readonly WarehouseControllerGetMovementPath = '/warehouse/movements/{idMovement}';

  /**
   * Restituisce un movimento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerGetMovement()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetMovement$Response(params: WarehouseControllerGetMovement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovement;
}>> {
    return warehouseControllerGetMovement(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un movimento.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerGetMovement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetMovement(params: WarehouseControllerGetMovement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseMovement;
}> {
    return this.warehouseControllerGetMovement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovement;
}>): BaseResponse & {
'data'?: WarehouseMovement;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerDeleteMovement()` */
  static readonly WarehouseControllerDeleteMovementPath = '/warehouse/movements/{idMovement}';

  /**
   * Elimina un movimento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerDeleteMovement()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerDeleteMovement$Response(params: WarehouseControllerDeleteMovement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovement;
}>> {
    return warehouseControllerDeleteMovement(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un movimento.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerDeleteMovement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerDeleteMovement(params: WarehouseControllerDeleteMovement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseMovement;
}> {
    return this.warehouseControllerDeleteMovement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovement;
}>): BaseResponse & {
'data'?: WarehouseMovement;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerStock()` */
  static readonly WarehouseControllerStockPath = '/warehouse/stock-from-warehouse_stock_actual';

  /**
   * Restituisce la giacenza in base ai filtri applicati.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerStock$Response(params: WarehouseControllerStock$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockResponse;
}>> {
    return warehouseControllerStock(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la giacenza in base ai filtri applicati.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerStock(params: WarehouseControllerStock$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseStockResponse;
}> {
    return this.warehouseControllerStock$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockResponse;
}>): BaseResponse & {
'data'?: WarehouseStockResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerStockFromWarehouseStockActualByAgreement()` */
  static readonly WarehouseControllerStockFromWarehouseStockActualByAgreementPath = '/warehouse/stock-from-warehouse_stock_actual-by-agreement';

  /**
   * Restituisce la giacenza da WarehouseStockActualByAgreemnt in base ai filtri applicati.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerStockFromWarehouseStockActualByAgreement()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerStockFromWarehouseStockActualByAgreement$Response(params: WarehouseControllerStockFromWarehouseStockActualByAgreement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockByAgreemntResponse;
}>> {
    return warehouseControllerStockFromWarehouseStockActualByAgreement(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la giacenza da WarehouseStockActualByAgreemnt in base ai filtri applicati.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerStockFromWarehouseStockActualByAgreement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerStockFromWarehouseStockActualByAgreement(params: WarehouseControllerStockFromWarehouseStockActualByAgreement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseStockByAgreemntResponse;
}> {
    return this.warehouseControllerStockFromWarehouseStockActualByAgreement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockByAgreemntResponse;
}>): BaseResponse & {
'data'?: WarehouseStockByAgreemntResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerCalculateAndGetStockByDate()` */
  static readonly WarehouseControllerCalculateAndGetStockByDatePath = '/warehouse/stock-by-date';

  /**
   * Restituisce la giacenza per data dallo stock WarehouseStockActual.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerCalculateAndGetStockByDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerCalculateAndGetStockByDate$Response(params: WarehouseControllerCalculateAndGetStockByDate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockResponse;
}>> {
    return warehouseControllerCalculateAndGetStockByDate(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la giacenza per data dallo stock WarehouseStockActual.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerCalculateAndGetStockByDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerCalculateAndGetStockByDate(params: WarehouseControllerCalculateAndGetStockByDate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseStockResponse;
}> {
    return this.warehouseControllerCalculateAndGetStockByDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockResponse;
}>): BaseResponse & {
'data'?: WarehouseStockResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate()` */
  static readonly WarehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDatePath = '/warehouse/stock-by-agreement-by-date';

  /**
   * Restituisce la giacenza per data dallo stock WarehouseStockActualByAgreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate$Response(params: WarehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockByAgreemntResponse;
}>> {
    return warehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la giacenza per data dallo stock WarehouseStockActualByAgreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate(params: WarehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseStockByAgreemntResponse;
}> {
    return this.warehouseControllerCalculateAndGetStockFromWarehouseStockActualByAgreementByDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockByAgreemntResponse;
}>): BaseResponse & {
'data'?: WarehouseStockByAgreemntResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerGetStockInOffice()` */
  static readonly WarehouseControllerGetStockInOfficePath = '/warehouse/stock/office/{id}';

  /**
   * Restituisce la giacenza di una sede.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerGetStockInOffice()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetStockInOffice$Response(params: WarehouseControllerGetStockInOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockResponse;
}>> {
    return warehouseControllerGetStockInOffice(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la giacenza di una sede.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerGetStockInOffice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetStockInOffice(params: WarehouseControllerGetStockInOffice$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseStockResponse;
}> {
    return this.warehouseControllerGetStockInOffice$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockResponse;
}>): BaseResponse & {
'data'?: WarehouseStockResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerGetStockOfProduct()` */
  static readonly WarehouseControllerGetStockOfProductPath = '/warehouse/stock/product/{id}';

  /**
   * Restituisce la giacenza di un prodotto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerGetStockOfProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetStockOfProduct$Response(params: WarehouseControllerGetStockOfProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockOfProductResponse;
}>> {
    return warehouseControllerGetStockOfProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la giacenza di un prodotto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerGetStockOfProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetStockOfProduct(params: WarehouseControllerGetStockOfProduct$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseStockOfProductResponse;
}> {
    return this.warehouseControllerGetStockOfProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseStockOfProductResponse;
}>): BaseResponse & {
'data'?: WarehouseStockOfProductResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerGetMovable()` */
  static readonly WarehouseControllerGetMovablePath = '/warehouse/movable-products/{idOrder}';

  /**
   * Restituisce l'elenco dei prodotti movimentabili a partire da un ordine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerGetMovable()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetMovable$Response(params: WarehouseControllerGetMovable$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MovableItemList;
}>> {
    return warehouseControllerGetMovable(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei prodotti movimentabili a partire da un ordine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerGetMovable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetMovable(params: WarehouseControllerGetMovable$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MovableItemList;
}> {
    return this.warehouseControllerGetMovable$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MovableItemList;
}>): BaseResponse & {
'data'?: MovableItemList;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerGetLoadedSerialNumbers()` */
  static readonly WarehouseControllerGetLoadedSerialNumbersPath = '/warehouse/loaded-serial-numbers';

  /**
   * Restituisce l'elenco dei seriali caricati a partire da un ordine in un qualsiasi magazzino.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerGetLoadedSerialNumbers()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetLoadedSerialNumbers$Response(params: WarehouseControllerGetLoadedSerialNumbers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MovableItemList;
}>> {
    return warehouseControllerGetLoadedSerialNumbers(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei seriali caricati a partire da un ordine in un qualsiasi magazzino.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerGetLoadedSerialNumbers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerGetLoadedSerialNumbers(params: WarehouseControllerGetLoadedSerialNumbers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MovableItemList;
}> {
    return this.warehouseControllerGetLoadedSerialNumbers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MovableItemList;
}>): BaseResponse & {
'data'?: MovableItemList;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerLoadFromOrder()` */
  static readonly WarehouseControllerLoadFromOrderPath = '/warehouse/load';

  /**
   * Crea un carico magazzino a partire da un ordine.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerLoadFromOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerLoadFromOrder$Response(params: WarehouseControllerLoadFromOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovement;
}>> {
    return warehouseControllerLoadFromOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un carico magazzino a partire da un ordine.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerLoadFromOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerLoadFromOrder(params: WarehouseControllerLoadFromOrder$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseMovement;
}> {
    return this.warehouseControllerLoadFromOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovement;
}>): BaseResponse & {
'data'?: WarehouseMovement;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerCreateTransfer()` */
  static readonly WarehouseControllerCreateTransferPath = '/warehouse/transfer';

  /**
   * Crea un trasferimento tra magazzini.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerCreateTransfer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateTransfer$Response(params: WarehouseControllerCreateTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return warehouseControllerCreateTransfer(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un trasferimento tra magazzini.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerCreateTransfer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateTransfer(params: WarehouseControllerCreateTransfer$Params, context?: HttpContext): Observable<void> {
    return this.warehouseControllerCreateTransfer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `warehouseControllerCreateDispose()` */
  static readonly WarehouseControllerCreateDisposePath = '/warehouse/dispose';

  /**
   * Smaltisce con scarico gli asset che sono in una sede RAEE: uscita definitiva, note obbligatorie (es. numero del FIR).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerCreateDispose()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateDispose$Response(params: WarehouseControllerCreateDispose$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return warehouseControllerCreateDispose(this.http, this.rootUrl, params, context);
  }

  /**
   * Smaltisce con scarico gli asset che sono in una sede RAEE: uscita definitiva, note obbligatorie (es. numero del FIR).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerCreateDispose$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateDispose(params: WarehouseControllerCreateDispose$Params, context?: HttpContext): Observable<void> {
    return this.warehouseControllerCreateDispose$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `warehouseControllerCreateDisposeDdt()` */
  static readonly WarehouseControllerCreateDisposeDdtPath = '/warehouse/dispose-ddt';

  /**
   * Smaltisce gli asset che sono in una sede RAEE con un DDT verso un fornitore (uno per magazzino): uscita definitiva, note obbligatorie (es. numero del FIR).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerCreateDisposeDdt()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateDisposeDdt$Response(params: WarehouseControllerCreateDisposeDdt$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return warehouseControllerCreateDisposeDdt(this.http, this.rootUrl, params, context);
  }

  /**
   * Smaltisce gli asset che sono in una sede RAEE con un DDT verso un fornitore (uno per magazzino): uscita definitiva, note obbligatorie (es. numero del FIR).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerCreateDisposeDdt$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateDisposeDdt(params: WarehouseControllerCreateDisposeDdt$Params, context?: HttpContext): Observable<void> {
    return this.warehouseControllerCreateDisposeDdt$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `warehouseControllerCreateSpecialMove()` */
  static readonly WarehouseControllerCreateSpecialMovePath = '/warehouse/special-move';

  /**
   * Sposta asset con seriale verso o da le sedi guasti, RAEE e smarriti del magazzino (segnalazione guasto, ripristino, da smaltire, smarrimento, ritrovamento).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerCreateSpecialMove()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateSpecialMove$Response(params: WarehouseControllerCreateSpecialMove$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return warehouseControllerCreateSpecialMove(this.http, this.rootUrl, params, context);
  }

  /**
   * Sposta asset con seriale verso o da le sedi guasti, RAEE e smarriti del magazzino (segnalazione guasto, ripristino, da smaltire, smarrimento, ritrovamento).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerCreateSpecialMove$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateSpecialMove(params: WarehouseControllerCreateSpecialMove$Params, context?: HttpContext): Observable<void> {
    return this.warehouseControllerCreateSpecialMove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `warehouseControllerCreateAdjustment()` */
  static readonly WarehouseControllerCreateAdjustmentPath = '/warehouse/adjustment';

  /**
   * Crea una rettifica inventariale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerCreateAdjustment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateAdjustment$Response(params: WarehouseControllerCreateAdjustment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return warehouseControllerCreateAdjustment(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una rettifica inventariale.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerCreateAdjustment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateAdjustment(params: WarehouseControllerCreateAdjustment$Params, context?: HttpContext): Observable<void> {
    return this.warehouseControllerCreateAdjustment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `warehouseControllerCreateReturn()` */
  static readonly WarehouseControllerCreateReturnPath = '/warehouse/return';

  /**
   * Crea un rientro.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerCreateReturn()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateReturn$Response(params: WarehouseControllerCreateReturn$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return warehouseControllerCreateReturn(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un rientro.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerCreateReturn$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateReturn(params: WarehouseControllerCreateReturn$Params, context?: HttpContext): Observable<void> {
    return this.warehouseControllerCreateReturn$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `warehouseControllerCreateUnload()` */
  static readonly WarehouseControllerCreateUnloadPath = '/warehouse/unload';

  /**
   * Crea uno scarico.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerCreateUnload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateUnload$Response(params: WarehouseControllerCreateUnload$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return warehouseControllerCreateUnload(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea uno scarico.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerCreateUnload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerCreateUnload(params: WarehouseControllerCreateUnload$Params, context?: HttpContext): Observable<void> {
    return this.warehouseControllerCreateUnload$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `warehouseControllerFindSerialsByWarehouseMovement()` */
  static readonly WarehouseControllerFindSerialsByWarehouseMovementPath = '/warehouse/movements/{id}/serials';

  /**
   * Restituisce i seriali movimentati per un movimento di magazzino.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerFindSerialsByWarehouseMovement()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerFindSerialsByWarehouseMovement$Response(params: WarehouseControllerFindSerialsByWarehouseMovement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovementSerialsListResponse;
}>> {
    return warehouseControllerFindSerialsByWarehouseMovement(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce i seriali movimentati per un movimento di magazzino.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerFindSerialsByWarehouseMovement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerFindSerialsByWarehouseMovement(params: WarehouseControllerFindSerialsByWarehouseMovement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: WarehouseMovementSerialsListResponse;
}> {
    return this.warehouseControllerFindSerialsByWarehouseMovement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovementSerialsListResponse;
}>): BaseResponse & {
'data'?: WarehouseMovementSerialsListResponse;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerIsSerialInAssetManagement()` */
  static readonly WarehouseControllerIsSerialInAssetManagementPath = '/warehouse/serialNumber/{serialNo}/isSerialInAssetManagement';

  /**
   * Restituisce 200 se la coppia ID prodotto - seriale è già presente in asset management.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerIsSerialInAssetManagement()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerIsSerialInAssetManagement$Response(params: WarehouseControllerIsSerialInAssetManagement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
    return warehouseControllerIsSerialInAssetManagement(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce 200 se la coppia ID prodotto - seriale è già presente in asset management.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerIsSerialInAssetManagement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerIsSerialInAssetManagement(params: WarehouseControllerIsSerialInAssetManagement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementItem;
}> {
    return this.warehouseControllerIsSerialInAssetManagement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>): BaseResponse & {
'data'?: AssetManagementItem;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerIsAssetManagementMovable()` */
  static readonly WarehouseControllerIsAssetManagementMovablePath = '/warehouse/isAssetManagementMovable';

  /**
   * Restituisce 200 se l'asset management è movimentabile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerIsAssetManagementMovable()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerIsAssetManagementMovable$Response(params: WarehouseControllerIsAssetManagementMovable$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItemEssential;
}>> {
    return warehouseControllerIsAssetManagementMovable(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce 200 se l'asset management è movimentabile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerIsAssetManagementMovable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerIsAssetManagementMovable(params: WarehouseControllerIsAssetManagementMovable$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AssetManagementItemEssential;
}> {
    return this.warehouseControllerIsAssetManagementMovable$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItemEssential;
}>): BaseResponse & {
'data'?: AssetManagementItemEssential;
} => r.body)
    );
  }

  /** Path part for operation `warehouseControllerGenerateStock()` */
  static readonly WarehouseControllerGenerateStockPath = '/warehouse/test-stock';

  /**
   * Ricalcola la giacenza.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerGenerateStock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerGenerateStock$Response(params: WarehouseControllerGenerateStock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return warehouseControllerGenerateStock(this.http, this.rootUrl, params, context);
  }

  /**
   * Ricalcola la giacenza.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerGenerateStock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  warehouseControllerGenerateStock(params: WarehouseControllerGenerateStock$Params, context?: HttpContext): Observable<void> {
    return this.warehouseControllerGenerateStock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `warehouseControllerRecalculateallStocks()` */
  static readonly WarehouseControllerRecalculateallStocksPath = '/warehouse/all-stock';

  /**
   * Ricalcola tutte le giacenze.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `warehouseControllerRecalculateallStocks()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerRecalculateallStocks$Response(params?: WarehouseControllerRecalculateallStocks$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return warehouseControllerRecalculateallStocks(this.http, this.rootUrl, params, context);
  }

  /**
   * Ricalcola tutte le giacenze.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `warehouseControllerRecalculateallStocks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  warehouseControllerRecalculateallStocks(params?: WarehouseControllerRecalculateallStocks$Params, context?: HttpContext): Observable<void> {
    return this.warehouseControllerRecalculateallStocks$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
